module.exports = __webpack_public_path__ + "static/media/CoinToss.634dacc9.png";